export default __webpack_public_path__ + "static/digital-sig-863053d05945d865722c63967d38ea8c.png";